// TICKET-01347: "Påminnelse" on the invoice heading/subject must not be inferred
// from daysOverDue alone. With no sale.dueDate and no customer.invoiceDueDays the
// computed due date collapses to saleDate, so a sale invoiced more than 7 days
// after its saleDate would be labeled a reminder the very first time. Require a
// previously recorded delivery in sale.reminders (stamped by the backend email/SMS
// send routes) in addition to being overdue.
export function showReminderLabel({ daysOverDue = 0, reminders = null, suppressReminder = false } = {}) {
    if (suppressReminder) {
        return false;
    }
    if (!(daysOverDue > 7)) {
        return false;
    }
    return Array.isArray(reminders) && reminders.length > 0;
}

export default showReminderLabel;
